import {Component, Event, EventEmitter, h, Host, State} from '@stencil/core';
import {translate, endpoint_api} from "../../../utils/utils";
import {DateTime} from "luxon";
import ticketIcon from '../../../assets/icons/ticket.svg';
import helpIcon from '../../../assets/logo/help.svg';

@Component({
  tag: 'ike-event-stream',
  styleUrl: 'ike-event-stream.scss',
  shadow: false,
})
export class IkeEventStream {
  private dateId: any;
  private code: any;
  private interval: NodeJS.Timeout;
  private unsub = [];

  @State() config: any;
  @State() begin: any;
  @State() event: any;
  @State() channel: string;
  @State() time: string;
  @State() vod: string;
  @State() hash: string;
  @State() endentry: DateTime;
  @State() test: string;
  @State() token: string;
  @State() diff: any;
  @State() start: any;
  @State() started: boolean;
  @State() valid: boolean;
  @State() submiting: boolean = false;

  @Event() getUtils: EventEmitter;
  @Event() ike_notification: EventEmitter;
  private utils: any;

  componentWillLoad() {
    this.getUtils.emit(utils=>this.utils=utils);
    this.dateId = this.dateId || this.utils.route.get('dateId');
    this.unsub.push(this.utils.config(config => this.config = config));
    this.utils.http('get', `/date/${this.dateId}?infos=true`).then(event => {
      this.event = event
      if(this.event.type == 'irl' && !this.event.has_stream){
        this.utils.goTo(`/event/${this.dateId}`)
      }
      if(this.event?.date) {
        this.start = DateTime.fromFormat(
          (this.event.type == 'live' || this.event.has_stream) ? this.event.date : this.event.doors,
          'yyyy-MM-dd HH:mm:ss'
        );
        // console.log(DateTime, DateTime.fromFormat('2021-02-18 20:00:00', 'yyyy-MM-dd HH:mm:ss').diffNow(['days', 'hours', 'minutes', 'seconds']).toObject())
        // this.start = DateTime.local().plus({seconds: 10});
        this.interval = setInterval(() => {
          this.started = this.start.diffNow().toObject().milliseconds<0;
          this.diff = this.start.diffNow(['days', 'hours', 'minutes', 'seconds']).toObject();
          if(this.started){
            clearInterval(this.interval);
          }
        }, 1000);
      }
    })

    let urlParams = new URLSearchParams(window.location.search);

    if(urlParams.get('code')){
      this.code = urlParams.get('code');
    }
  }

  disconnectedCallback(){
    this.unsub.forEach(call=>call())
  }

  private onSubmit(event){
    event.preventDefault();
    if(!this.code){
      return this.ike_notification.emit(['error',translate("Le code est invalide. Veuillez utiliser le code qui vous a ete envoye par mail.")]);
    }

    this.fetchStream();
  }

  private fetchStream(){
    this.submiting = true;
    const forcedEndpoint = endpoint_api=='https://etickets.infomaniak.com' ? 'https://streaming.etickets.infomaniak.com' : endpoint_api;
    this.utils.http('post', `/date/${this.dateId}/stream`, {
      code: this.code,
    }, {}, forcedEndpoint).finally(()=>this.submiting=false).then(resp => {
      this.valid = resp.valid;
      if(resp.test) {
        this.test = resp.test;
      }
      if(resp.channel && resp.token){
        this.channel = resp.channel;
        this.token = resp.token;
      }
      if(resp.vod){
        this.vod = resp.vod;
      }
      if(resp.hash){
        this.hash = resp.hash;
      }
      if(resp.hash){
        this.time = resp.time;
      }
      if(resp.endentry){
        this.endentry = DateTime.fromISO(resp.endentry);
      }
      if(resp.wait && resp.wait<2147483647){
        setTimeout(()=>this.fetchStream(), resp.wait)
      }
      if(resp.begin){
        this.begin = DateTime.fromFormat(resp.begin, 'yyyy-MM-dd HH:mm:ss');
      }
      if(resp.error){
        switch (resp.error){
          case 'nodate':
            this.ike_notification.emit(['error',translate("Evenement introuvable.")]);
            break;
          case 'noticket':
            this.ike_notification.emit(['error',translate("Le code est invalide. Veuillez utiliser le code qui vous a ete envoye par mail.")]);
            break;
          case 'toolate':
            if((this.event.type == 'live' || this.event.has_stream)){
              this.ike_notification.emit(['error',translate("Cette representation est termine, a tres bientot")]);
            }else if(this.dateId == 708495){
              this.ike_notification.emit(['error', "Le code d’accès que vous avez renseigné a déjà été utilisé il y a plus de 30 jours. Nous espérons que vous avez pleinement profité du spectacle. A très bientôt !"]);
            }else{
              this.ike_notification.emit(['error',"Le code d’accès que vous avez renseigné a déjà utilisé il y a plus de 48h pour visionner “MA CUISINE INTERIEURE“. Nous espérons que vous avez pleinement profité du spectacle. A très bientôt !"]);
            }
            break;
          case 'toosoon':
            this.ike_notification.emit(['error',translate("Une autre representation est en cours veuillez reessayer plus tard")]);
            break;
        }
      }
    })
  }

  private onInput(event:any) {
    event.target.value = this.code = event.target?.value.toUpperCase().replace(/\s/g, '')
  }

  private renderTitle(){
    return <div>
      <div class="stream-title">
        {this.config?.logo &&
          <p class="stream-title--logo">
            <img src={this.config?.logo} alt={this.event?.name}/>
          </p>
        }
      </div>

      <div class="stream-countdown">
        <div class="stream-countdown_poster">
          <img src={this.event?.img} alt={this.event?.name}/>
        </div>

        {this.event?.date && this.started && (this.event.type == 'live' || this.event.has_stream) &&
          <div class="stream-countdown_content">
            <p><strong>{this.event?.name}</strong></p>
            {(this.event?.type == 'live' || this.event?.has_stream) &&
              <p class="stream-countdown_date">{this.start?.toFormat("cccc d LLLL 'a' H'h'mm").replace('h00', 'h')}</p>
            }
            <div class="stream-countdown_direct"><span class="stream-countdown_direct__bullet">●</span> {translate("en direct")}</div>
          </div>
        }

        {this.event?.date && this.started && this.event.type == 'vod' &&
          <div class="stream-countdown_content">
            <p><strong>{this.event?.name}</strong></p>
            {(this.event?.type == 'live' || this.event?.has_stream) &&
              <p class="stream-countdown_date">{this.start?.toFormat("cccc d LLLL 'a' H'h'mm").replace('h00', 'h')}</p>
            }
            <div class="stream-countdown_direct">{translate("Duree : {time}", {time:this.time||'1:09:39'})}</div>
          </div>
        }

        {!this.started && this.diff &&
          <div class="stream-countdown_content">
            <p><strong>{this.event?.name}</strong></p>
            <div class="stream-countdown_numbers stream-countdown_numbers__titles">
              <div class="stream-countdown_numbers__number">{translate("Jours")}</div>
              <div class="stream-countdown_numbers__number"/>
              <div class="stream-countdown_numbers__number">{translate("Heures")}</div>
              <div class="stream-countdown_numbers__number"/>
              <div class="stream-countdown_numbers__number">{translate("Minutes")}</div>
              <div class="stream-countdown_numbers__number"/>
              <div class="stream-countdown_numbers__number">{translate("Secondes")}</div>
            </div>
            <div class="stream-countdown_numbers">
              <div class="stream-countdown_numbers__number">{this.diff?.days.toString().padStart(2, '0')}</div>
              <div class="stream-countdown_numbers__number">:</div>
              <div class="stream-countdown_numbers__number">{this.diff?.hours.toString().padStart(2, '0')}</div>
              <div class="stream-countdown_numbers__number">:</div>
              <div class="stream-countdown_numbers__number">{this.diff?.minutes.toString().padStart(2, '0')}</div>
              <div class="stream-countdown_numbers__number">:</div>
              <div class="stream-countdown_numbers__number">{Math.floor(this.diff?.seconds).toString().padStart(2, '0')}</div>
            </div>
          </div>
        }
      </div>
    </div>
  }

  private getStream() : Array<string>{
    let stream = ''
    if(this.channel && this.token){
      stream = `https://player.infomaniak.com/?channel=${this.channel}&token=${this.token}`
    }else if(this.test){
      stream = `https://player.infomaniak.com/?channel=${this.test}`
    }else if(this.hash){
      stream = this.hash;
    }else if(this.vod){
      stream = `https://vod.infomaniak.com/iframe.php?${this.vod}`;
    }
    return (typeof stream == 'string' ? [stream] : stream);
  }

  render() {
    return <Host style={{"--posterbg": 'url("'+this.event?.imgs?.blur+'")'}}>
      <div class="stream-main">
        {this.renderTitle()}

        {!this.valid && !this.begin &&
          <form class="stream-main_form" onSubmit={event=>this.onSubmit(event)}>
            <p class="stream-main_line">
              <img class="stream-icon" src={ticketIcon} alt={translate('Ticket icon')}/>
            </p>
              <p class="stream-main_line">
                {(this.event?.type == 'live' || this.event?.has_stream) &&
                  translate("Saisissez ici le code de votre billet pour acceder au direct.")
                }
                {this.event?.type == 'vod' &&
                  translate("Saisissez ici le code de votre billet pour acceder a la video.")
                }
              </p>
            <p class="stream-main_line">
              <input class="stream-main_input" type="text" placeholder="Code" value={this.code} onInput={event => this.onInput(event)}/>
            </p>
            <div class="stream-main_line flex flex-wrap-reverse gap-10 justify-content-center">
              <button onClick={() => this.utils.goTo(`/event/${this.event?.id}`)} class="button btn-label" type='button'>
                {translate("Acheter un billet")}
              </button>
              <ike-button-loader classNames={{'stream-main_button' :true}} loading={this.submiting} type='submit' color="grey-dark">
                {!this.submiting && translate("Valider")}
              </ike-button-loader>
            </div>
          </form>
        }

        {this.begin &&
          <div class="stream-video">
            <div>
              <p class="stream-main_line stream-video_title">{translate("La video n'est pas encore disponible")}</p>
              <p class="stream-main_line stream-video_subtitle">{translate("la video sera visionnable a partir du {begin}", {
                begin: this.begin.toFormat("cccc d LLLL, HH'h'mm")
              })}</p>
            </div>
          </div>
        }

        {this.valid &&
          <div class="stream-video">
            {!this.getStream() &&
              <div>
                <p class="stream-main_line stream-video_title">{translate("Le direct n'a pas commence")}</p>
                <p class="stream-main_line stream-video_subtitle">{translate("Lorsque l'evenement commencera, cette page se mettra automatiquement a jour")}</p>
              </div>
            }

            {this.getStream()?.map(src=>
              <p class="stream-main_line">
                <iframe class="stream-video_frame" frameborder="0" allowFullScreen src={src}/>
              </p>
            )}
            {this.getStream() &&
              <p class="stream-main_line">
                <p>{translate("Vous pouvez visioner cette video jusqu'au {date}", {date:this.endentry?.toFormat('yyyy-MM-dd')})}</p>
              </p>
            }
          </div>
        }
      </div>

      <div class="stream-sidebar">
        {this.renderTitle()}

        {this?.config?.period?.email && this?.config?.period?.phone &&
          <div class="stream-help">
            <div>
              <img class="stream-help_icon" src={helpIcon} alt={translate('Help icon')}/>
            </div>

            <div>
              {(
                parts => [parts[1], <a href={'mailto:'+this?.config?.period?.email} target="_blank">{this?.config?.period?.email}</a>, parts[2]]
              ) (/^(.*?)\[EMAIL](.*?)$/.exec(
                translate("Besoin d'aide ? N'hesitez pas a nous contacter par mail sur [EMAIL].")
              ))}
            </div>
          </div>
        }
      </div>
    </Host>;
  }
}
